import ProofreadingOrder from '@/models/read/ProofreadingOrder';
import factory from 'frontend-resources/js/Factory/ProofreadingOrderFactory.js';

export default $axios => ({ store }) => ({
    async show(id) {
        let order = await $axios.$get(`/api/v1/proofreading/orders/${id}`);
        return new ProofreadingOrder(order.data);
    },

    async getV2(id) {
        let order = await $axios.$get(`/api/v2/proofreading/orders/${id}`);

        return factory.fromApiResponse(order);
    },

    delete(id) {
        return $axios.$delete(`/api/v1/orders/${id}`);
    },

    async getSelectedDocumentPageModels(orderId) {
        try {
            let response = await $axios.$get(`/api/v1/proofreading/orders/${orderId}/selected-document`);

            return response.data.attributes.pageModels;
        } catch (error) {
            return [];
        }
    },

    async list() {
        let response = await $axios.$get(`/api/v1/proofreading/students/me/orders`);

        return response.data.map(o => new ProofreadingOrder(o)).sort((a, b) => a.id > b.id ? -1 : 1);
    },
});
